import ok from '@/ok-utils/ok.js'

export default {
  html_cdn_add(html) {
    var reg = new RegExp("src=\"/uploads/", "g");
    html = (html + "").replace(reg, "src=\"" + ok.config.url_cdn + "/uploads/");
    reg = new RegExp("src=\"\\.\\./appfile/", "g");
    html = (html + "").replace(reg, "src=\"" + ok.config.url_cdn + "/appfile/");
    reg = new RegExp("src=\"/appfile/", "g");
    html = (html + "").replace(reg, "src=\"" + ok.config.url_cdn + "/appfile/");
    return html;
  },
  html_cdn_del(html) {
    var reg = new RegExp(ok.config.url_cdn, "g");
    html = (html + "").replace(reg, "");
    return html;
  },
  txt_to_html(txt) {
    txt = (txt + "").replace(/\n/g, "<br />");
    return txt;
  },
  to_distance(x) {
    var f = parseFloat(x);
    if (isNaN(f)) {
      return 0;
    }
    f = f / 1000;
    var f = Math.round(f * 100) / 100;
    var s = f.toString();
    var rs = s.indexOf('.');
    if (rs < 0) {
      rs = s.length;
      s += '.';
    }
    while (s.length <= rs + 2) {
      s += '0';
    }
    return s;
  },
  to_price(x) {
    var f = parseFloat(x);
    if (isNaN(f)) {
      return 0;
    }
    //var f1 = x / 100;
    var f1 = x;
    var f = Math.round(f1 * 100) / 100;
    var s = f.toString();
    var rs = s.indexOf('.');
    if (rs < 0) {
      rs = s.length;
      s += '.';
    }
    while (s.length <= rs + 2) {
      s += '0';
    }
    return s;
  },
  to_price_left(x) {
    var price = this.to_price(x) + "";
    price = price.split('.')[0];
    return price;
  },
  to_price_right(x) {
    var price = this.to_price(x) + "";
    price = price.split('.')[1];
    return price;
  },
  to_text(value, list) {
    for (var i = 0; i !== list.length; ++i) {
      if (list[i].value == value) {
        return list[i].text;
      }
    }
    return "";
  },
  to_value(text, list) {
    for (var i = 0; i !== list.length; ++i) {
      if (list[i].text == text) {
        return list[i].value;
      }
    }
    return "";
  },
  list_format(list, text, value) {
    var _return = new Array();
    for (var i = 0; i !== list.length; ++i) {
      _return.push({
        value: list[i][value],
        text: list[i][text],
      });
    }
    return _return;
  },
  list_format_splicing(list, text, value, splic) {
    if (splic == null) splic = " ";
    var _return = new Array();
    for (var i = 0; i !== list.length; ++i) {
      var _texts = text.toString().split(",");
      var _text_info = "";
      _texts.map((item) => {
        if (_text_info == "") {
          _text_info = list[i][item];
        } else {
          _text_info = _text_info + splic + list[i][item];
        }
      });

      var _values = value.toString().split(",");
      var _value_info = "";
      _values.map((item) => {
        if (_value_info == "") {
          _value_info = list[i][item];
        } else {
          _value_info = _value_info + splic + list[i][item];
        }
      });

      _return.push({
        text: _text_info,
        value: _value_info,
      });
    }
    return _return;
  },
  list_filter_text(list, text) {
    return this.list_filter(list, "text", text);
  },
  list_filter_value(list, value) {
    return this.list_filter(list, "value", value);
  },
  list_filter(list, type, value) {
    var _list = [];
    if (value.constructor == Array) {
      _list = value;
    } else {
      _list.push(value);
    }

    //console.log(_list);
    var _return = [];
    list.map((item) => {
      // console.log(item[type]);
      // console.log(_list.indexOf(item[type]));
      if (_list.indexOf(item[type]) < 0) {
        _return.push(item);
      }
    });
    // console.log(_return);
    return _return;
  },

  list_disable_text(list, text) {
    return this.list_disable(list, "text", text);
  },
  list_disable_value(list, value) {
    return this.list_disable(list, "value", value);
  },
  list_disable(list, type, value) {
    var _list = [];
    if (value.constructor == Array) {
      _list = value;
    } else {
      _list.push(value);
    }

    //console.log(_list);
    var _return = [];
    list.map((item) => {
      // console.log(item[type]);
      // console.log(_list.indexOf(item[type]));
      if (_list.indexOf(item[type]) < 0) {
        item.disable = false;
        _return.push(item);
      } else {
        item.disable = true;
        _return.push(item);
      }
    });
    // console.log(_return);
    return _return;
  },
  list_obj_to_list(list, value) {
    var _return = new Array();
    for (var i = 0; i !== list.length; ++i) {
      _return.push(list[i][value]);
    }
    return _return;
  },
  list_del_list(list1, list2, key) {
    var _return = new Array();
    for (var item1 of list1) {
      var _add = 1;
      for (var item2 of list2) {
        if (item1[key] == item2[key])
          _add = 0;
      }
      if (_add == 1)
        _return.push(item1);
    }
    return _return;
  },
  id_code_to_age(identityCard) {
    var len = (identityCard + "").length;
    if (len == 0) {
      return '';
    } else {
      if ((len != 15) && (len != 18)) //身份证号码只能为15位或18位其它不合法
      {
        return '';
      }
    }
    var strBirthday = "";
    if (len == 18) //处理18位的身份证号码从号码中得到生日和性别代码
    {
      strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
    }
    if (len == 15) {
      strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
    }
    //时间字符串里，必须是“/”
    var birthDate = new Date(strBirthday);
    var nowDateTime = new Date();
    var age = nowDateTime.getFullYear() - birthDate.getFullYear();
    //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
    if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

}
